import { Box, Flex, Text } from '@chakra-ui/layout';

import styles from './tooltip-content.module.css';

type Row = {
  label: string;
  value: string;
};

type TooltipContentProps = {
  title: string;
  subtitle: string;
  rows: Row[];
};

/**
 * The Chakra style props carry the exact legacy look; the CSS-module classes
 * override them under body[data-theme].
 */
export const TooltipContent = ({
  title,
  subtitle,
  rows,
}: TooltipContentProps) => {
  return (
    <Box>
      <Text
        fontSize="13px"
        fontWeight="600"
        color="white"
        className={styles.title}
      >
        {title}
      </Text>
      <Text
        fontSize="11px"
        fontWeight="600"
        color="white"
        marginBottom="16px"
        className={styles.subtitle}
      >
        {subtitle}
      </Text>

      {rows.map((row) => (
        <Flex key={row.label} paddingBottom="6px" className={styles.row}>
          <Text
            fontSize="10px"
            color="#D7DBE3"
            marginRight="40px"
            className={styles.rowLabel}
          >
            {row.label}
          </Text>
          <Text fontSize="10px" color="#D7DBE3" className={styles.rowValue}>
            {row.value}
          </Text>
        </Flex>
      ))}
    </Box>
  );
};
